import { gql, useMutation } from 'urql';
import { toast } from 'sonner';

import ResetPasswordForm from '@/ui/login/ResetPasswordForm';
import { ForgotPasswordInput } from '@/ui/login/ResetPasswordForm/schema';

const resetPasswordQuery = gql`
  mutation RequestPasswordReset($email: String!) {
    requestPasswordReset(email: $email)
  }
`;

export default function ResetPasswordScreen() {
  const [, resetPassword] = useMutation(resetPasswordQuery);

  async function onSubmit({ email }: ForgotPasswordInput) {
    try {
      const result = await resetPassword(
        { email },
        {
          fetchOptions: {
            credentials: 'include',
            mode: 'cors',
          },
        },
      );

      if (result.data?.requestPasswordReset) {
        toast.success('Check your email for reset instructions');
      } else {
        throw new Error();
      }
    } catch (error) {
      toast.error('Failed to reset password. Please contact our support.');
    }
  }

  return <ResetPasswordForm onSubmit={onSubmit} />;
}
